// =============================================================================
// CONFIGURATION
// =============================================================================

export const CONFIG = {
  // Layout
  width: 1400,
  height: 900,
  
  // Outcome detection - clusters matching these patterns go on the right
  outcomePatterns: [
    'pain', 'function', 'progress', 'outcome', 'recovery', 'quality of life',
    'measuring', 'mobility', 'strength', 'score'
  ],
  
  // Or manually specify outcome cluster IDs (overrides auto-detect if non-empty)
  manualOutcomeClusterIds: [],
  
  // Visual settings
  minClusterRadius: 30,
  maxClusterRadius: 70,
  expandedRadiusMultiplier: 1.6,
  minChildRadius: 12,
  maxChildRadius: 28,
  edgeOpacity: 0.5,
  
  // Colors for clinical interpretation
  clinicalColors: {
    'very_beneficial': '#15803d',
    'beneficial': '#22c55e',
    'neutral': '#94a3b8',
    'harmful': '#f97316',
    'very_harmful': '#dc2626',
    'not_applicable': '#cbd5e1',
    'unknown': '#cbd5e1'
  },
  
  // Initial hierarchy level
  initialLevel: 1,
};
